// @ts-nocheck
import * as React from 'react';
// StatusDot — status indicator pill for parent cards.

export default function StatusDot({ status }) {
  const map = {
    new: { c: "var(--blue)", l: "New" },
    "in-demo": { c: "var(--green)", l: "In Demo" },
    considering: { c: "var(--amber)", l: "Considering" },
    decided: { c: "var(--fg-tertiary)", l: "Decided" },
  };
  const s = map[status] || map.new;
  return (
    <span
      className="pill"
      style={{
        background: "transparent",
        border: "1px solid var(--border)",
        padding: "3px 8px",
        fontSize: 10.5,
      }}
    >
      <span
        style={{
          width: 6,
          height: 6,
          borderRadius: 999,
          background: s.c,
        }}
      />
      {s.l}
    </span>
  );
}
